import React, { useEffect, useState } from 'react';
// import Nav from '../../components/nav/Nav'
import Header from '../../components/Header/Header';
import './service.css'
import Footer from '../../components/footer/Footer'
import { useStateValue } from '../../stateprovider';
import Download from '../../components/download/Download';
import { motion, useMotionValue } from "framer-motion";
import service1 from '../../assets/favdoctor-service-image.jpg';
import service2 from '../../assets/favdoctor-service-image-2.jpg'
import service3 from '../../assets/favdoctor-service-image-3.jpg'

const Services = () => {
    const [{ menu }, dispatch] = useStateValue();
    const [isFirstHovered, setFirstHovered] = useState(false);
    const [secondHovered, setSecondHovered] = useState(false);
    const [thirdHovered, setThirdHovered] = useState(false);
    useEffect(() => {
        dispatch({
            type: "MENU",
            menu: false
        });
        dispatch({
            type: "ACTIVE_NAVIGAtION",
            navigation: 'services'
        });

    }, [])

    return (
        <div className='favdoc_service'>

            <Header />
            <div className={(menu === true) ? 'notDisplay' : 'favdoc_service__display'}>
                <div className="favdoc__service-search">
                    <input type='text' placeholder='Search for FavoriteDoctor partner facility around you' />
                    <input type='text' placeholder='Search for  facilities around you' />

                </div>

                <div className="favdoc__service-row">
                    <div className='favdoc__service__row__column'>
                        <div className='favdoc__service-col'
                            onMouseEnter={() => setFirstHovered(true)}
                            onMouseLeave={() => setFirstHovered(false)}
                        >
                            <motion.div className="favdoc__service-row_content"
                                initial={false}
                                animate={{ display: isFirstHovered ? 'none' : 'flex', }}
                                transition={{
                                    ease: [0.17, 0.67, 0.83, 0.67]
                                }}
                                fade={true}
                            >

                                <h5>Medical Consultancy</h5>
                            </motion.div>
                            <motion.div className="favdoc__service-row_content_detail"
                                initial={false}
                                animate={{ display: isFirstHovered ? 'flex' : 'none', }}
                                transition={{
                                    ease: [0.17, 0.67, 0.83, 0.67]
                                }}
                                fade={true}
                            >
                                <img src={service1} alt={service1} />
                                <div className='favdoc__service-row_content_detail_text'>
                                    <h5>Medical Consultancy</h5>
                                    <p>Favourite Doctor aims to connect
                                        users to healthcare providers an
                                        empower providers for effective
                                        collaboration remotely.</p>
                                    <p>Learn More</p>

                                </div>
                            </motion.div>
                        </div>
                        <div className='favdoc__service-col'
                            onMouseEnter={() => setSecondHovered(true)}
                            onMouseLeave={() => setSecondHovered(false)}
                        >
                            <motion.div className="favdoc__service-row_content"
                                initial={false}
                                animate={{ display: secondHovered ? 'none' : 'flex', }}
                                transition={{
                                    ease: [0.17, 0.67, 0.83, 0.67]
                                }}
                                fade={true}
                            >

                                <h5>Book Appointment</h5>
                            </motion.div>
                            <motion.div className="favdoc__service-row_content_detail"
                                initial={false}
                                animate={{ display: secondHovered ? 'flex' : 'none', }}
                                transition={{
                                    ease: [0.17, 0.67, 0.83, 0.67]
                                }}
                                fade={true}
                            >
                                <img src={service2} alt={service2} />
                                <div className='favdoc__service-row_content_detail_text'>
                                    <h5>Book Appointment</h5>
                                    <p>We  help users to locate doctors,
                                        book appointments, order tests,
                                        access reports All these features
                                        are available.</p>
                                    <p>Learn More</p>

                                </div>
                            </motion.div>
                        </div>
                    </div>
                    <div className='favdoc__service__row__column favdoc__service__row__column__Two'>
                        <div className='favdoc__service-col'
                            onMouseEnter={() => setThirdHovered(true)}
                            onMouseLeave={() => setThirdHovered(false)}
                        >
                            <motion.div className="favdoc__service-row_content"
                                initial={false}
                                animate={{ display: thirdHovered ? 'none' : 'flex', }}
                                transition={{
                                    ease: [0.17, 0.67, 0.83, 0.67]
                                }}
                                fade={true}
                            >

                                <h5>Virtual Self-Tests</h5>
                            </motion.div>
                            <motion.div className="favdoc__service-row_content_detail"
                                initial={false}
                                animate={{ display: thirdHovered ? 'flex' : 'none', }}
                                transition={{
                                    ease: [0.17, 0.67, 0.83, 0.67]
                                }}
                                fade={true}
                            >
                                <img src={service3} alt={service3} />
                                <div className='favdoc__service-row_content_detail_text'>
                                    <h5>Virtual Self-Tests</h5>
                                    <p>We help users to locate doctors,
                                        book appointments, order tests,
                                        access reports All these features
                                        are available.</p>
                                    <p>Learn More</p>

                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
                <div className="favdoc__service-row favdoc__service__mobile">
                    <div className="favdoc__service__mobile__row">
                        <img src={service1} alt={service1} />
                        <div className="favdoc__service__mobile__content">
                            <h5>Medical Consultancy</h5>
                            <p>Favourite Doctor aims to connect
                                users to healthcare providers an
                                empower providers for effective
                                collaboration remotely.</p>
                        </div>
                    </div>
                    <div className="favdoc__service__mobile__row">
                        <div className="favdoc__service__mobile__content" style={{textAlign: 'left', alignItems: 'flex-start' }}>
                            <h5 style={{textAlign: 'left' }}>Book Appointment</h5>
                            <p style={{textAlign: 'left' }}>We  help users to locate doctors,
                                book appointments, order tests,
                                access reports All these features
                                are available.</p>
                        </div>
                        <img src={service2} alt={service2} />
                    </div>
                    <div className="favdoc__service__mobile__row">
                        <img src={service3} alt={service3} />
                        <div className="favdoc__service__mobile__content">
                            <h5>Virtual Self-Tests</h5>
                            <p>We help users to locate doctors,
                                book appointments, order tests,
                                access reports All these features
                                are available.</p>
                        </div>
                    </div>
                </div>
                <div className="favdoc__service__footer">
                    <Download />
                    <Footer />
                </div>

            </div>

        </div>
    )
}

export default Services